import { AppConfig } from './../../tamalelibs/models/app-config.model';
/**
 * Created by Yoyo Fang on 06/23/2020.
 * Description:
 * Intralinks folder grids inline buttons
 * ------ maintenance history ------
 * 08/04/2020 Marcus Zhao add submit intralink to entry
 */

import { Component, OnInit, OnDestroy } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { IntralinksFile, IntralinksMapping } from '../../tamalelibs/models/intralinks.model';
import { NoteDialogOpenOptions, NoteDialogType } from '../note-dialog/note-dialog.model';
import { NoteDialogService } from '../note-dialog/note-dialog.service';
import { IntralinksUIService } from '../../pages/feeds/intralinks/intralinks-ui.service';
import { Subscription } from 'rxjs';
import { TemplateService } from '../../tamalelibs/services/template.service';
import { TemplateControlValue } from '../../tamalelibs/models/template-control-value.model';
import { Store, select } from '@ngrx/store';
import { AppState } from '../../redux';
import { ToastService } from '../../widgets/toast/toast.service';
import { lastActionSelector } from '../../redux/reducers/action-history.reducer';
import { CREATE_NOTE_SUCCESS, CREATE_DRAFT_SUCCESS, CREATE_NOTE_FAILURE } from '../../tamalelibs/redux/note.actions';
import { NotificationStyles } from '../../widgets/notification/notification.model';
import { take, filter } from 'rxjs/operators';
import { WebTemplateViewModel } from '../template/template-web.view-model';
import { NoteBodyHtmlMetadatas } from '../../tamalelibs/constants/business.constants';
import * as _ from 'lodash';

@Component({
    selector: 'tam-intralinks-folder-actions',
    templateUrl: './intralinks-folder-actions.component.html',
    styleUrls: ['./intralinks-folder-actions.component.scss']
})
export class IntralinksFolderActionsComponent implements ICellRendererAngularComp, OnInit, OnDestroy {
    static readonly DEFAULTS = [
        { label: 'Source:', paramName: 'source' },
        { label: 'Display Date:', paramName: 'displaydate' },
        { label: 'Sentiment:', paramName: 'sentiment', value: 0 },
        { label: 'Priority:', paramName: 'priority', value: 0 }
    ];
    public item: IntralinksFile;
    public missMapping = true;
    public isSaving = false;
    // currentUser: User;
    private _destroySubscriptions: Array<Subscription> = [];
    private _defaults: any[] = [];
    constructor(
        private _noteDialogService: NoteDialogService,
        private _intralinksService: IntralinksUIService,
        private _templateService: TemplateService,
        private _noteTemplatePageViewModel: WebTemplateViewModel,
        private _store: Store<AppState>,
        private _toastService: ToastService
    ) { }
    agInit(params: any): void {
        this.item = params.data;

        this._defaults = _.cloneDeep(IntralinksFolderActionsComponent.DEFAULTS);
        this._defaults[0]['value'] = AppConfig.userId;
        if (!this.item.createdDate) {
            this._defaults[1]['value'] = new Date().getTime();
            // this._defaults.splice(1,1);
        } else {
            this._defaults[1]['value'] = this.item.createdDate.getTime();
        }
        this.missMapping = !this.item || !this.item.mapping || !this.item.mapping.noteType || !this.item.mapping.entities || this.item.mapping.entities.length < 1;
        if (!this.missMapping && this.item.mapping.requiredFields) {
            const defaultFields = this._defaults.map(item => item.label);
            const requiredFields = this.item.mapping.requiredFields.filter(item => !defaultFields.includes(item));
            requiredFields.forEach(id => {
                const index = this.item.mapping.fields.findIndex(field => field.adhocDefId ? field.adhocDefId === id : field.label === id);
                if (index < 0) {
                    this.missMapping = true;
                } else {
                    const isBoolean = ((typeof this.item.mapping.fields[index]) === 'boolean');
                    const hasValue = isBoolean || (!!this.item.mapping.fields[index].value);
                    this.missMapping = this.missMapping || !hasValue;
                }
            });
        }
    }
    ngOnInit() {
        // this.currentUser = this._storeQuerier.getCurrentUser();
        this._destroySubscriptions.push(
            this._intralinksService.setData$.subscribe(item => {
                this.item['screenId'] = item;
            }));
    }

    ngOnDestroy() {
        this._destroySubscriptions.forEach(subscription => subscription.unsubscribe());
    }

    refresh(): boolean {
        return true;
    }

    submit() {
        const _noteOption = new NoteDialogOpenOptions();
        _noteOption.openType = NoteDialogType.CreateNote;
        _noteOption.minimizable = true;
        _noteOption.intralinks = [this.item];
        if (this.item.mapping && this.item.mapping.noteType) {
            _noteOption.entryTypeId = this.item.mapping.noteType.id;
        }
        if (_noteOption.intralinks != null) {
            this._noteDialogService.dialogOpen$.next(_noteOption);
        }
    }

    quickSubmit() {
        this._saveNote(this.item.mapping);
    }

    private _saveNote(mapping: IntralinksMapping) {
        if (mapping.noteType && mapping.noteType.id) {
            this.isSaving = true;

            const formData = {
                body: NoteBodyHtmlMetadatas.fullHtml,
                keepdoc: false,
            };

            // prepare attachment
            formData['screen-id'] = this.item.screenId;
            formData['intralinks-workspace-id'] = this.item.workspaceId;
            formData['intralinks-file'] = [this.item.id + ':' + this.item.fileHash + ':' + this.item.name + this.item.extension];

            // prepare other fields
            const fields = mapping.fields; // mapping.fields.filter((field) => mapping.appliedFieldIds.includes(field.adhocDefId) || mapping.appliedFieldIds.includes(field.label));
            let params = this._templateService.buildEntryTemplateParamsForIntralinks(fields, mapping.noteType.id);
            params = this._setDefaultValue(params, this.item.createdDate, AppConfig.userId);
            if (mapping.entities && mapping.entities.length > 0) {
                params['entities'] = mapping.entities.map(entity => entity.id).join(';');
            }

            // prepare body
            const valueSet = {};
            fields.forEach(field => {
                valueSet[field.controlId] = _.cloneDeep(field);
                if (valueSet[field.controlId]['adhocDefId']) {
                    valueSet[field.controlId]['adhocDefId'] = 'x-' + valueSet[field.controlId]['adhocDefId'];
                }
            });
            formData.body = this._templateService.createNoteBodyHtml(valueSet);

            // save
            this._noteTemplatePageViewModel.createNote(params, formData, false, false, null, [this.item]);

            // callback
            this._store.pipe(
                select(lastActionSelector),
                filter(type => type === CREATE_NOTE_SUCCESS || type === CREATE_NOTE_FAILURE),
                take(1)
            ).subscribe(type => {
                if (type === CREATE_NOTE_SUCCESS) {
                    const toastMsg = 'File successfully submitted.';
                    this._noteTemplatePageViewModel.cleanTemplateMsg();
                    this._toastService.notify({
                        style: NotificationStyles.Info,
                        message: toastMsg,
                    });
                } else {
                    const toastMsg = 'Missing fields for Quick Submit.';
                    this._noteTemplatePageViewModel.cleanTemplateMsg();
                    this._toastService.notify({
                        style: NotificationStyles.Error,
                        message: toastMsg,
                    });
                    this.submit();
                }
                this.isSaving = false;
            });
        }
    }

    private _setDefaultValue(params: any, createDate: Date, currentUser) {
        this._defaults.forEach(item => {
            const missing = params[item.paramName] === undefined || params[item.paramName] === null;
            if (missing && item.value !== null) {
                params[item.paramName] = item.value;
            }
        });
        return params;
    }
}
